import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Trophy } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome back to CricketPulse");
      navigate("/dashboard");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5] flex items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20 bg-cover bg-center pointer-events-none"
           style={{ backgroundImage: `url('https://images.unsplash.com/photo-1730739463889-34c7279277a9?crop=entropy&cs=srgb&fm=jpg&q=85')` }} />
      <Link to="/" className="absolute top-8 left-1/2 -translate-x-1/2 flex items-center gap-3 group">
        <div className="w-10 h-10 rounded bg-[#FF3B30] flex items-center justify-center text-white font-black text-xl shadow-[0_0_15px_rgba(255,59,48,0.5)] group-hover:scale-105 transition-transform">CP</div>
        <h1 className="text-2xl font-black uppercase tracking-wider text-white">CRICKETPULSE</h1>
      </Link>
      <div className="relative z-10 w-full max-w-md bg-[#141414] border border-[#262626] rounded-2xl p-8 shadow-2xl space-y-6">
        <div className="space-y-2">
          <div className="inline-flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest text-[#FF3B30] bg-[#FF3B30]/10 border border-[#FF3B30]/30 rounded px-2.5 py-1">
            <Trophy className="w-3 h-3" /> Player Login
          </div>
          <h2 className="text-3xl font-black uppercase text-white">Welcome Back</h2>
          <p className="text-sm text-[#A3A3A3]">Sign in to review your form and coach report.</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-mono text-[#A3A3A3] uppercase mb-1">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#1A1A1A] border border-[#262626] rounded px-3 py-2.5 text-sm text-white focus:outline-none focus:border-[#FF3B30] transition-colors"
              placeholder="alex@cricket.com"
            />
          </div>
          <div>
            <div className="flex items-center justify-between mb-1">
              <label className="block text-xs font-mono text-[#A3A3A3] uppercase">Password</label>
              <Link
                data-testid="link-forgot-password"
                to="/forgot-password"
                className="text-[11px] font-mono text-[#FF3B30] hover:underline"
              >
                Forgot password?
              </Link>
            </div>
            <input
              data-testid="login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#1A1A1A] border border-[#262626] rounded px-3 py-2.5 text-sm text-white focus:outline-none focus:border-[#FF3B30] transition-colors"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div data-testid="login-error" className="bg-[#FF3B30]/10 border border-[#FF3B30]/40 text-[#FF3B30] text-xs rounded px-3 py-2">
              {error}
            </div>
          )}

          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={busy}
            className="w-full bg-[#FF3B30] hover:bg-[#E03229] disabled:opacity-50 text-white font-bold py-2.5 rounded text-sm transition-all shadow-lg"
          >
            {busy ? "Signing in..." : "SIGN IN"}
          </button>
        </form>

        <div className="text-center text-xs text-[#A3A3A3]">
          New player?{" "}
          <Link data-testid="link-to-register" to="/register" className="text-[#FF3B30] font-bold hover:underline">
            Create your account
          </Link>
        </div>
      </div>
    </div>
  );
}
